






























































































import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import {
  DeliveryCycleNumberType,
  GetRecurringPaymentsRequest,
  Mall,
  RecurringPaymentsSearchType
} from 'supporter';
import _ from 'underscore';
import { stringify } from 'qs';

import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import CheckBoxElement from '@/components/common/CheckBoxElement.vue';
import CompSelectBox, { CompSelectBoxOption } from '@/components/common/CompSelectBox.vue';

import {
  SearchFormOptions,
  options,
  getI18nOfThis, DEFAULT_STATE
} from '@/components/order/detail/orderRecurringPayments/SearchFormAssistant';
import {PeriodType} from '@/types';



export type QueryObject = Omit<GetRecurringPaymentsRequest['params'], 'page' | 'size'>

@Component({
  components: {
    PeriodDateCalendar,
    CheckBoxElement,
    CompSelectBox,
  }
})
export default class SearchForm extends Vue {
  private getI18nOfThis = getI18nOfThis;

  @Getter('mall/malls')
  private readonly malls!: Mall[];
  private options: SearchFormOptions = options({ periodInPeriodOption: Object.values(this.$route.query).length ? '' : '3m' });
  private mallSelectDisabled = false;
  private mallNo: number = 0;
  private searchKeywordType: RecurringPaymentsSearchType = 'PRODUCT_NAME';
  private searchKeywordValue = '';
  private startYmdt = '';
  private endYmdt = '';
  private deliveryCycles: string = 'ALL';

  private get mallOptions(): CompSelectBoxOption<number>[] {
    return this.malls.map(mall => ({
      name: mall.mallName, value: mall.mallNo
    }));
  }

  private mounted() {
    if (Object.values(this.$route.query).length) {
      this.mapQueryToForm();
      return;
    }
    this.resetMallSelect();
    this.resetDate();
  }

  private mapQueryToForm(): void {
    const queryObject = this.$route.query;
    const { mallNos, searchType, keywords, startYmd, endYmd, deliveryCycles } = queryObject as { [key: string] : string };
    this.mallNo = mallNos.split(',').length === this.malls.length ? 0 : Number(mallNos);
    this.searchKeywordType = searchType as RecurringPaymentsSearchType;
    this.searchKeywordValue = keywords ?? '';
    this.startYmdt = startYmd;
    this.endYmdt = endYmd;
    this.deliveryCycles = deliveryCycles.split(',').length === this.options.deliveryCycleOptions.data.length - 1 ?
        'ALL' : deliveryCycles;
  }

  private resetMallSelect(): void {
    const lastCreatedMall = this.malls[0];
    this.mallNo = lastCreatedMall.mallNo;
    if (this.malls.length === 1) {
      this.mallSelectDisabled = true;
      return;
    }
  }

  private resetDate() {
    const dateCalendar = this.$refs.dateCalendar as PeriodDateCalendar;
    const { start, end } = dateCalendar.getPeriod(this.options.periodOption.period as PeriodType);

    this.startYmdt = start;
    this.endYmdt = end;
  }

  private makeQueryObject(): QueryObject {
    const deliveryCycles = (
        this.deliveryCycles === 'ALL' ?
          _.range(1, 7)
          :
          this.deliveryCycles.split(',').map(cycle => Number(cycle))
    ) as DeliveryCycleNumberType[];

    const queryObject: QueryObject = {
      mallNos: this.mallNo ? [this.mallNo] : this.malls.map((mall: Mall) => mall.mallNo),
      searchType: this.searchKeywordType,
      startYmd: this.startYmdt,
      endYmd: this.endYmdt,
      deliveryCycles: deliveryCycles as unknown as string[],
      keywords: this.searchKeywordValue
          .split(/[,\n]/)
          .filter(Boolean)
          .map(keyword => keyword.trim()),
    }

    return queryObject;
  }

  private handleSearchBtnClick(): void {
    const queryObject = this.makeQueryObject();
    queryObject['dataRefresh'] = (new Date()).toString();
    this.$router.replace(this.$route.path + '?' + stringify(queryObject, {
      arrayFormat: 'comma',
      skipNulls: true,
    }));
  }

  private handleResetBtnClick(): void {
    Object.entries(DEFAULT_STATE).forEach(([key, value]) => {
      this[key] = value;
    });
    this.resetMallSelect();
    this.resetDate();
  }
}
